<template>
  <b-table
    class="limit-overflow"
    :items="form"
    :fields="campos"
    ref="selectableTable"
    show-empty
    :empty-text="$t('GERAL.NENHUM_REGISTRO')"
    head-variant="light"
    responsive
    striped
    hover
  >
    <template #cell(valor)="data">
      <b-input-group class="mt-3">
        <input-number
          :value="data.item.valor"
          @input="atualizarValor(data.item, 'valor', $event)"
          :min="0"
          :max="10"
          class="mb-2"
          size="sm"
          decimal
        />
      </b-input-group>
    </template>
  </b-table>
</template>

<script>
// Components:
import { InputNumber } from '@/components/inputs';

export default {
  components: {
    InputNumber,
  },
  props: {
    form: { type: Array, default: Array },
  },
  watch: {
    form: {
      handler() {
        this.$emit('atualizado', this.form);
      },
      deep: true,
    },
  },
  data() {
    return {
      campos: [
        {
          key: 'nomeAluno',
          label: this.$t('ACADEMICO.ALUNO'),
          sortable: true,
        },
        {
          key: 'valor',
          sortable: true,
          label: this.$t('ACADEMICO.NOTA_RECUPERACAO'),
        },
      ],
    };
  },
  methods: {
    atualizarValor(item, campo, valor) {
      if (valor === '' || valor === null || valor === undefined) {
        item[campo] = null;
      } else {
        const numero = parseFloat(valor);
        if (!isNaN(numero)) {
          item[campo] = numero;
        }
      }
    },
  },
};
</script>

<style>
td .input-group {
  height: auto !important;
  margin: 0px !important;
}

table td,
table th,
.table td,
.table th {
  padding: 0px 12px;
}
</style>